const systemCommandsBody = {
  androidEraseDeviceText: ['**Are you sure you want to erase this device?**', '**Everything on the hard drive, including Android app, is removed and can\'t be recovered.** The device will restart once Android software is reinstalled.'],
  androidEraseDeviceOnSuccess: 'Erase security command sent to device.',
  androidLockDeviceText: ['**Are you sure** you want to lock this lost Android device?', 'The device will remain locked until the user enters the Android passcode.'],
  androidLockDeviceTextOnSuccess: 'Lock security command sent to device.',
};

export default {
  systemCommandsBody,
};
